import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";
import { adminFetch } from "../utils/adminAuth";

/*
  CR U3 — "Sub-domain summary: Show a summary of sub-domains inside the
  Admin panel." Lists every activated Personal and Business website domain.
*/
export default function AdminSubdomains() {
    const [summary, setSummary] = useState({ total: 0, business: 0, personal: 0 });
    const [domains, setDomains] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("all");
    const [q, setQ] = useState("");

    useEffect(() => {
        adminFetch(`${API_BASE}/api/get_subdomains_summary.php`)
            .then((r) => r.json())
            .then((data) => {
                if (data.success) {
                    setSummary(data.summary);
                    setDomains(data.domains);
                }
            })
            .finally(() => setLoading(false));
    }, []);

    const query = q.trim().toLowerCase();
    const filtered = domains.filter((d) => {
        if (filter !== "all" && d.type !== filter) return false;
        if (!query) return true;
        return `${d.domain} ${d.site_name} ${d.owner_name} ${d.owner_email}`.toLowerCase().includes(query);
    });

    return (
        <div>
            <h5 className="fw-bold mb-1">Sub-domain Summary</h5>
            <p className="text-secondary small mb-3">Every activated Personal and Business website, with its owner.</p>

            <div className="row g-2 mb-3">
                <div className="col-md-4">
                    <div className="card shadow-sm text-center py-2"><div className="fs-4 fw-bold">{summary.total}</div><div className="text-secondary small">Total Sub-domains</div></div>
                </div>
                <div className="col-md-4">
                    <div className="card shadow-sm text-center py-2"><div className="fs-4 fw-bold">{summary.business}</div><div className="text-secondary small">Business Websites</div></div>
                </div>
                <div className="col-md-4">
                    <div className="card shadow-sm text-center py-2"><div className="fs-4 fw-bold">{summary.personal}</div><div className="text-secondary small">Personal Websites</div></div>
                </div>
            </div>

            <div className="d-flex gap-2 mb-3 flex-wrap">
                <select className="form-select form-select-sm w-auto" value={filter} onChange={(e) => setFilter(e.target.value)}>
                    <option value="all">All types</option>
                    <option value="business">Business only</option>
                    <option value="personal">Personal only</option>
                </select>
                <input className="form-control form-control-sm w-auto flex-grow-1" placeholder="Search domain, site name, or owner..." value={q} onChange={(e) => setQ(e.target.value)} />
            </div>

            <div className="card shadow-sm">
                <div className="card-body p-0">
                    {loading ? (
                        <div className="p-3">Loading...</div>
                    ) : filtered.length === 0 ? (
                        <div className="p-3 text-secondary">No sub-domains match.</div>
                    ) : (
                        <table className="table table-sm mb-0">
                            <thead className="table-light">
                                <tr><th>Domain</th><th>Site Name</th><th>Type</th><th>Owner</th><th>Created</th><th></th></tr>
                            </thead>
                            <tbody>
                                {filtered.map((d, i) => (
                                    <tr key={i}>
                                        <td className="fw-semibold">{d.domain}</td>
                                        <td>{d.site_name}</td>
                                        <td><span className={`badge bg-${d.type === "business" ? "primary" : "info"}`}>{d.type}</span></td>
                                        <td className="small">{d.owner_name}<br /><span className="text-secondary">{d.owner_email}</span></td>
                                        <td className="text-secondary small">{d.created_at}</td>
                                        <td>
                                            <a className="btn btn-sm btn-outline-secondary" href={`/${d.domain}`} target="_blank" rel="noopener noreferrer">View →</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
